import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

import ContentFeedAssignedCreativesModal from "widgets/modals/contentfeeds/ContentFeedAssignedCreativesModal";
import RefreshContentFeedModal from "widgets/modals/contentfeeds/RefreshContentFeedModal";
import ToggleAutoUpdatesModal from "widgets/modals/contentfeeds/ToggleAutoUpdatesModal";
import ViewContentFeedDetailsModal from "widgets/modals/contentfeeds/ViewContentFeedDetailsModal";
import CreativePreviewBlade from "widgets/modals/creatives/preview/CreativePreviewBlade";
import PreviewBlade from "widgets/modals/creatives/social/PreviewBlade";

const MODAL_ROUTES = [
	{
		path: `/library/:libraryId/content-feeds/modal/assigned-creatives/:contentFeedId/`,
		component: ContentFeedAssignedCreativesModal,
	},
	{
		path: `/library/:libraryId/content-feeds/modal/refresh/:contentFeedId/`,
		component: RefreshContentFeedModal,
	},
	{
		path: `/library/:libraryId/content-feeds/modal/toggle-auto-updates/:contentFeedId/`,
		component: ToggleAutoUpdatesModal,
	},
	{
		path: `/library/:libraryId/content-feeds/modal/view-details/:contentFeedId/`,
		component: ViewContentFeedDetailsModal,
	},
];

function createModalRoute({ path, component: ModalComponent }, onCloseModal) {
	return (
		<Route
			key={path}
			exact
			path={path}
			render={() => <ModalComponent onClose={onCloseModal} />}
		/>
	);
}

export default function ContentFeedModals() {
	const dispatch = useDispatch();
	const { url } = useRouteMatch();

	function onCloseModal() {
		dispatch(push(`${url}/`));
	}

	return (
		<Switch>
			<Route
				exact
				path={`/library/:libraryId/content-feeds/modal/preview-creative/:type/:creativeId/`}
				render={(routeRenderProps) => {
					const { libraryId, creativeId, type } = routeRenderProps.match.params;
					const returnPathFromState = routeRenderProps.location.state?.returnPath;
					const contentFeedId = routeRenderProps.location.state?.contentFeedId;
					const contentFeedName = routeRenderProps.location.state?.contentFeedName;

					let returnPath = url;
					if (returnPathFromState) {
						returnPath = returnPathFromState;
					} else if (contentFeedId) {
						returnPath = `${url}/modal/assigned-creatives/${contentFeedId}/`;
					}

					const returnState = { contentFeedName };
					const modalProps = {
						libraryId,
						creativeId,
						returnPath,
						returnState,
					};

					if (/social/gi.test(type)) {
						return <PreviewBlade {...modalProps} />;
					}
					return (
						<CreativePreviewBlade {...modalProps} />
					);
				}}
			/>
			{MODAL_ROUTES.map(routeConfig => createModalRoute(routeConfig, onCloseModal))}
		</Switch>
	);
}

ContentFeedModals.displayName = "ContentFeedModals";
